import PostCard, { type PostCardProps } from '@/components/Post/PostCard'
import usePost from '@/utils/hooks/usePost'

export interface PostSearchResultItemProps extends Omit<PostCardProps, 'data'> {
	id: string
}

export default function PostSearchResultItem({ id, ...props }: PostSearchResultItemProps) {
	const data = usePost(id)
	if (!data) {
		return
	}
	return <PostCard data={data} {...props} />
}
